'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationResult = exports.SchemaError = exports.YamlError = undefined;
exports.validateInboundFilterRules = validateInboundFilterRules;
exports.validateInboundTransformRules = validateInboundTransformRules;

var _inboundFilters = require('./inboundFilters');

var _inboundFilters2 = _interopRequireDefault(_inboundFilters);

var _inboundTransforms = require('./inboundTransforms');

var _inboundTransforms2 = _interopRequireDefault(_inboundTransforms);

var _ajv = require('ajv');

var _ajv2 = _interopRequireDefault(_ajv);

var _jsYaml = require('js-yaml');

var _jsYaml2 = _interopRequireDefault(_jsYaml);

var _flowRuntime = require('flow-runtime');

var _flowRuntime2 = _interopRequireDefault(_flowRuntime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YamlError = exports.YamlError = _flowRuntime2.default.type('YamlError', _flowRuntime2.default.object(_flowRuntime2.default.property('line', _flowRuntime2.default.number()), _flowRuntime2.default.property('column', _flowRuntime2.default.number()), _flowRuntime2.default.property('reason', _flowRuntime2.default.string()), _flowRuntime2.default.property('message', _flowRuntime2.default.string())));

var SchemaError = exports.SchemaError = _flowRuntime2.default.type('SchemaError', _flowRuntime2.default.object(_flowRuntime2.default.property('keyword', _flowRuntime2.default.string()), _flowRuntime2.default.property('dataPath', _flowRuntime2.default.string()), _flowRuntime2.default.property('schemaPath', _flowRuntime2.default.string()), _flowRuntime2.default.property('params', _flowRuntime2.default.any()), _flowRuntime2.default.property('message', _flowRuntime2.default.string())));

var ValidationResult = exports.ValidationResult = _flowRuntime2.default.type('ValidationResult', _flowRuntime2.default.object(_flowRuntime2.default.property('valid', _flowRuntime2.default.boolean()), _flowRuntime2.default.property('yamlError', YamlError, true), _flowRuntime2.default.property('schemaErrors', _flowRuntime2.default.array(SchemaError), true)));

var ajvInboundFilters = new _ajv2.default().compile(_inboundFilters2.default);
var ajvInboundTransforms = new _ajv2.default().compile(_inboundTransforms2.default);

// TODO: Would be nice to make the two functions DRY

function validateInboundFilterRules(rulesYaml) {
  var _rulesYamlType = _flowRuntime2.default.string();

  var _returnType = _flowRuntime2.default.return(ValidationResult);

  _flowRuntime2.default.param('rulesYaml', _rulesYamlType).assert(rulesYaml);

  try {
    var rules = _jsYaml2.default.safeLoad(rulesYaml);
    var _valid = ajvInboundFilters(rules);
    if (!_valid) {
      return _returnType.assert({ valid: false, schemaErrors: ajvInboundFilters.errors });
    }
  } catch (e /* YAMLException */) {
    // https://github.com/nodeca/js-yaml/blob/c76b837cacc69de6b86a0781db31a9bb7a193875/lib/js-yaml/exception.js#L5
    return _returnType.assert({
      valid: false,
      yamlError: {
        line: e.mark.line,
        column: e.mark.column,
        message: e.message,
        reason: e.reason
      }
    });
  }
  return _returnType.assert({ valid: true });
}

_flowRuntime2.default.annotate(validateInboundFilterRules, _flowRuntime2.default.function(_flowRuntime2.default.param('rulesYaml', _flowRuntime2.default.string()), _flowRuntime2.default.return(ValidationResult)));

function validateInboundTransformRules(rulesYaml) {
  var _rulesYamlType2 = _flowRuntime2.default.string();

  var _returnType2 = _flowRuntime2.default.return(ValidationResult);

  _flowRuntime2.default.param('rulesYaml', _rulesYamlType2).assert(rulesYaml);

  try {
    var rules = _jsYaml2.default.safeLoad(rulesYaml);
    var _valid2 = ajvInboundTransforms(rules);
    if (!_valid2) {
      return _returnType2.assert({ valid: false, schemaErrors: ajvInboundTransforms.errors });
    }
  } catch (e /* YAMLException */) {
    // https://github.com/nodeca/js-yaml/blob/c76b837cacc69de6b86a0781db31a9bb7a193875/lib/js-yaml/exception.js#L5
    return _returnType2.assert({
      valid: false,
      yamlError: {
        line: e.mark.line,
        column: e.mark.column,
        message: e.message,
        reason: e.reason
      }
    });
  }
  return _returnType2.assert({ valid: true });
}

_flowRuntime2.default.annotate(validateInboundTransformRules, _flowRuntime2.default.function(_flowRuntime2.default.param('rulesYaml', _flowRuntime2.default.string()), _flowRuntime2.default.return(ValidationResult)));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@segment/event-rules/build/index.js
// module id = 1045
// module chunks = 0